import React, {useCallback, useEffect, useState} from 'react';
import Checkbox from "../../../../../components/checkbox";
import lodash from 'lodash';
import _ from 'lodash';
import {useList} from "react-use";

import {Collapse} from 'react-collapse';

const getNumCheck = (value) => {
    let i = 0;
    lodash.filter(value,item => {
        if(item.check) i++;
    })
    return i;
}

function PitchType(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const [totalCondition, setTotalCondition] = useState({
        straight: selected.straight,
        changingSphere: selected.changingSphere
    })
    const [listSphere] = useList([
        {
            id: 3,
            name: 'シュート',
            check: false
        },
        {
            id: 9,
            name: 'カットボール',
            check: false
        },
        {
            id: 5,
            name: 'フォーク',
            check: false
        },
        {
            id: 7,
            name: 'チェンジアップ',
            check: false
        }, {
            id: 6,
            name: 'シンカー',
            check: false
        }, {
            id: 4,
            name: 'スライダー',
            check: false
        }, {
            id: 2,
            name: 'カーブ',
            check: false
        }, {
            id: -1,
            name: 'その他',
            check: false
        }
    ])
    const [isCheckStraight, setIsCheckStraight] = useState(false);
    const [isCheckTotalSphere, setIsCheckTotalSphere] = useState(false);

    useEffect(() => {
        if (selected.straight) {
            setIsCheckStraight(true)
        }else {
            setIsCheckStraight(false)
        }
        if (selected.changingSphere.length > 0) {
            selected.changingSphere.map(item => {
                const index = listSphere.findIndex(i => i.id === item);
                listSphere[index].check = true;
            })
            if (selected.changingSphere.length === listSphere.length) setIsCheckTotalSphere(true);
        }

    }, [selected])
    useEffect(() => {
        props.onChange(totalCondition)
    }, [totalCondition])

    useEffect(() => {
        if (_.isEmpty(totalCondition.changingSphere)) {
            setIsCheckTotalSphere(false);
            return
        }
        if(totalCondition.changingSphere.length !== getNumCheck(totalCondition.changingSphere)) {
            setIsCheckTotalSphere(false);
        }
    }, [totalCondition.changingSphere])

    const onClickStraight = useCallback((e) => {
        const val = Number(e.target.value);
        setIsCheckStraight(!isCheckStraight);
        setTotalCondition(state => ({...state, straight: state.straight ? null : val}))
    }, []);
    const onClickTotalSphere = useCallback(() => {
        setIsCheckTotalSphere(!isCheckTotalSphere);
        if (!isCheckTotalSphere) {
            const arr = [];
            const cpList = [...listSphere];
            cpList.forEach(i => {
                arr.push(i.id);
                i.check = true
            })
            setTotalCondition(state => ({...state, changingSphere: arr}))
        } else {
            const cpList = [...listSphere];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition(state => ({...state, changingSphere: []}))
        }

    }, [isCheckTotalSphere])

    const onCheckSphere = useCallback((val) => {
        const arr = [...totalCondition.changingSphere];
        const cpList = [...listSphere];

        const index = _.indexOf(arr, Number(val));
        const i = _.findIndex(cpList, item => item.id === Number(val))
        if (index === -1) {
            arr.push(Number(val));
            cpList[i].check = true;
        } else {
            arr.splice(index, 1);
            cpList[i].check = false;
        }
        setTotalCondition(state => ({...state, changingSphere: arr}));
    })
    return (
        <div className='group-filter-item'>
            <div className={'open-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)} >
                    <h4>球種</h4>
                    <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
                </div>
                <Collapse isOpened={isOpened}>
                    <div>
                        <div style={{ width: '100%'}}>
                            <div className='search-main-advanced-checkbox'>
                                <label>
                                    <Checkbox id='31' checked={isCheckStraight} onClick={onClickStraight} value={1} />
                                    ストレート
                                </label>
                            </div>
                            <div className='search-main-advanced-checkbox'>
                                <label>
                                    <Checkbox checked={isCheckTotalSphere} onClick={onClickTotalSphere}/>
                                    変化球
                                </label>
                            </div>
                            <div className="wrap-group">
                                {listSphere.map(item => {
                                    return (
                                        <div key={item.id} className='search-main-advanced-checkbox'>
                                            <label>
                                                <Checkbox checked={item.check} onClick={() => onCheckSphere(item.id)}/>
                                                {item.name}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
            <div className={'close-collapse'}>
                <div className='toggle-collapse'>
                    <h4>球種</h4>
                </div>
                    <div>
                        <div style={{ width: '100%'}}>
                            <div className='search-main-advanced-checkbox'>
                                <label>
                                    <Checkbox id='31' checked={isCheckStraight} onClick={onClickStraight}/>
                                    ストレート
                                </label>
                            </div>
                            <div className='search-main-advanced-checkbox'>
                                <label>
                                    <Checkbox checked={isCheckTotalSphere} onClick={onClickTotalSphere}/>
                                    変化球
                                </label>
                            </div>
                            <div className="wrap-group">
                                {listSphere.map(item => {
                                    return (
                                        <div key={item.id} className='search-main-advanced-checkbox'>
                                            <label>
                                                <Checkbox checked={item.check} onClick={() => onCheckSphere(item.id)}/>
                                                {item.name}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
            </div>

        </div>
    )
}

export default PitchType;
